var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-component d-flex align-items-center"},_vm._l((_vm.num),function(item,index){return _c('div',{key:index},[_c('span',{staticClass:"fa fa-star yellow"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }